import React from "react";
import PropTypes from "prop-types";

import style from "./style.module.css";
import ButtonShowMore from "../ButtonShowMore/ButtonShowMore";

const FrameworkTitle = ({ title, titleColor, id, hasMoreContents }) => {
  const renderTitle = <p>{title}</p>;

  return (
    <div className={style.titulo} style={titleColor ? { color: titleColor } : undefined}>
      {renderTitle}
      {hasMoreContents && <ButtonShowMore id={id} />}
    </div>
  );
};

FrameworkTitle.propTypes = {
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  hasMoreContents: PropTypes.bool.isRequired,
};

FrameworkTitle.defaultProps = {
  hasMoreContents: false,
};

export default FrameworkTitle;
